var _g, _path, _path2, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 423,
    viewBox: "0 0 554 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383 299L376 306L369 299",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.448 144.939C484.36 91.0507 409.096 0.639984 277 0.639984C144.904 0.639984 69.64 91.0507 36.552 144.939C26.3233 161.483 20.9052 180.549 20.9052 200C20.9052 219.451 26.3233 238.517 36.552 255.061C69.64 308.949 144.904 399.36 277 399.36C409.096 399.36 484.36 308.949 517.448 255.061C527.677 238.517 533.095 219.451 533.095 200C533.095 180.549 527.677 161.483 517.448 144.939ZM481.075 232.725C452.659 278.933 388.339 356.693 277 356.693C165.661 356.693 101.341 278.933 72.9253 232.725C66.8482 222.892 63.6293 211.56 63.6293 200C63.6293 188.44 66.8482 177.108 72.9253 167.275C101.341 121.067 165.661 43.3067 277 43.3067C388.339 43.3067 452.659 120.981 481.075 167.275C487.152 177.108 490.371 188.44 490.371 200C490.371 211.56 487.152 222.892 481.075 232.725Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277 93.3333C255.903 93.3333 235.28 99.5892 217.739 111.31C200.198 123.031 186.526 139.69 178.453 159.18C170.379 178.671 168.267 200.118 172.383 220.81C176.499 241.501 186.658 260.507 201.575 275.425C216.493 290.342 235.499 300.501 256.19 304.617C276.882 308.733 298.329 306.62 317.82 298.547C337.31 290.474 353.969 276.802 365.69 259.261C377.411 241.72 383.667 221.097 383.667 200C383.633 171.721 372.384 144.609 352.387 124.613C332.391 104.616 305.279 93.3672 277 93.3333ZM277 264C264.342 264 251.968 260.246 241.443 253.214C230.919 246.182 222.716 236.186 217.872 224.492C213.028 212.797 211.76 199.929 214.23 187.514C216.699 175.099 222.795 163.696 231.745 154.745C240.696 145.795 252.099 139.699 264.514 137.23C276.929 134.76 289.797 136.028 301.492 140.872C313.186 145.716 323.182 153.919 330.214 164.443C337.246 174.968 341 187.342 341 200C341 216.974 334.257 233.252 322.255 245.255C310.252 257.257 293.974 264 277 264Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.8666,
    y1: 368.378,
    x2: 518.867,
    y2: 26.3785,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "translate(368 298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeToggle);
export default __webpack_public_path__ + "static/media/eye-toggle.266f559126997ba099833e50442137a0.svg";
export { ForwardRef as ReactComponent };